import { LoadScriptProps, useJsApiLoader } from '@react-google-maps/api'
import { createContext, useContext, useMemo } from 'react'

import { env } from 'src/env/client.mjs'

export type GoogleMapsState = {
  isLoaded: boolean
  loadError?: Error
}

const GoogleMapsContext = createContext<GoogleMapsState>({
  isLoaded: false
})

const LIBRARIES: LoadScriptProps['libraries'] = [
  'drawing',
  'geometry',
  'places'
]

export const GoogleMapsProvider = ({ children }: { children: any }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || '',
    language: 'en',
    libraries: LIBRARIES
  })

  const memoisedValue = useMemo(
    () => ({
      isLoaded,
      loadError
    }),
    [isLoaded, loadError]
  )

  return (
    <GoogleMapsContext.Provider value={memoisedValue}>
      {children}
    </GoogleMapsContext.Provider>
  )
}

export const useGoogleMaps = () => useContext(GoogleMapsContext)
